export const TransactionStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  DECLINED: "declined",
  AWAITING_PAYMENT: "awaiting_payment",
  PAYMENT_PROCESSING: "payment_processing",
  PAID: "paid",
};
